import { Button } from "@/components/ui/Button";
import React from "react";
import { ProtectedNavLink } from "@/components/ProtectedNavigationLink";
import { type RouteId } from "@/routes/getRoute";

interface CongratsActionLinkButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  route: RouteId;
  params?: Record<string, string>;
}

export const CongratsActionLinkButton = ({
  children,
  onClick,
  route,
  params,
}: CongratsActionLinkButtonProps) => {
  return (
    <Button
      variant="link"
      onClick={onClick}
      className="text-2xl font-normal text-blue-primary"
      asChild
    >
      <ProtectedNavLink route={route} params={params}>
        {children}
      </ProtectedNavLink>
    </Button>
  );
};
